import React from "react";
import PropTypes from "prop-types"
import {Table} from 'antd';
import {NavLink} from "react-router-dom"
import {defaultPagination, makeDefaultFilters} from "../../util/Util"


const SelectionTable = ({dataSource, onSelectChange, loading}) => {
    const columns = [
        {title: 'Selection', dataIndex: 'selection', filters: makeDefaultFilters(dataSource, d => d.selection), render: (text, record) => <NavLink to={`/selection/${text}`}>{text}</NavLink>},
        {title: 'Type', dataIndex: 'type'}
    ];

    const rowSelection = {
        type: 'radio',
        onChange: (selectedRowKeys, selectedRows) => {
            if (selectedRowKeys.length > 0) onSelectChange(selectedRowKeys[0])
        }
    };

    return <Table dataSource={dataSource} loading={loading}
                  columns={columns}  bordered
                  rowKey={record => record.id}
                  rowSelection={rowSelection} pagination={defaultPagination()}
    />
};
SelectionTable.propTypes = {
    dataSource: PropTypes.array.isRequired,
    onSelectChange: PropTypes.func,
    loading: PropTypes.bool.isRequired,
    compact: PropTypes.bool.isRequired
};

export default SelectionTable



// WEBPACK FOOTER //
// ./src/js/browse/selection/SelectionTable.js